var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgControle3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2002 21.6006C6.7002 21.6006 2.2002 17.1006 2.2002 11.6006C2.2002 7.60056 4.6002 4.00056 8.2002 2.40056C8.6002 2.30056 9.0002 2.40056 9.3002 2.60056C9.6002 2.80056 9.7002 3.30056 9.6002 3.60056C9.3002 4.50056 9.2002 5.30056 9.2002 6.10056C9.2002 10.5006 12.8002 14.1006 17.2002 14.1006C18.3002 14.1006 19.4002 13.9006 20.4002 13.4006C20.8002 13.2006 21.2002 13.3006 21.5002 13.6006C21.8002 13.9006 21.9002 14.3006 21.8002 14.6006C20.4002 18.8006 16.6002 21.6006 12.2002 21.6006ZM7.2002 5.40056C5.3002 6.90056 4.2002 9.20056 4.2002 11.7006C4.2002 16.1006 7.8002 19.7006 12.2002 19.7006C15.0002 19.7006 17.5002 18.3006 18.9002 16.1006C18.3002 16.2006 17.8002 16.2006 17.2002 16.2006C11.7002 16.2006 7.2002 11.7006 7.2002 6.20056C7.2002 5.90056 7.2002 5.60056 7.2002 5.40056Z",
    fill: "#012124"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7002 9.59961H15.7002C15.3002 9.59961 14.9002 9.29961 14.8002 8.89961C14.7002 8.49961 14.8002 8.09961 15.1002 7.79961L17.9002 5.59961H16.0002C15.4002 5.59961 15.0002 5.19961 15.0002 4.59961C15.0002 3.99961 15.4002 3.59961 16.0002 3.59961H20.7002C21.1002 3.59961 21.5002 3.89961 21.6002 4.29961C21.7002 4.69961 21.6002 5.09961 21.3002 5.39961L18.5002 7.59961H20.6002C21.2002 7.59961 21.6002 7.99961 21.6002 8.59961C21.6002 9.19961 21.3002 9.59961 20.7002 9.59961Z",
    fill: "#012124"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControle3);
export default __webpack_public_path__ + "static/media/controle3.f36cdd7a11179808a68c607c85c65dca.svg";
export { ForwardRef as ReactComponent };